export interface PaymentProvider {
  id?: string
  businessName?: string
  email?: string
  loginLink?: string
  bank_accounts?: Array<object>
  applePayDomains: ApplePayDomain[]
  // createdAt?: moment.Moment
}

export interface ApplePayDomain {
  name: string
  id?: string
  deleted?: boolean
}

export enum PAYMENT_PROVIDER {
  STRIPE = 'stripe',
  TILLED = 'tilled',
}
